var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: "radio-group-" + _vm.name },
    _vm._l(_vm.choices, function(item, key) {
      return _c(
        "el-radio",
        {
          key: key,
          attrs: { label: item.value, name: _vm.name, disabled: _vm.disabled },
          on: { change: _vm.handleChange },
          model: {
            value: _vm.inputRadioModel,
            callback: function($$v) {
              _vm.inputRadioModel = $$v
            },
            expression: "inputRadioModel"
          }
        },
        [_vm._v("\n    " + _vm._s(item.label) + "\n  ")]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }